import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { Link, IDEFileExtensions } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  Link,
  IDEFileExtensions,
  React
};